import { AxiosResponse } from "axios";
import { instance } from "../network/ApiCall";

export async function getDeclarationTypeListAPI() {
  const response = await instance.get('/coicategory/getConflictCategory');
  return response.data;
}

export async function getMyDeclarationAPI(data: any) {
  const response = await instance.get(
    `/coi/getCoi?q=${data?.q}&conflictCategoryMasterId=${data?.conflictCategoryMasterId}&year=${data?.year}`
  );
  return response.data;
}

export async function addMyDeclarationAPI(data: any) {
  const response = await instance.post("/coi/addCoi", data);
  return response.data;
}

export async function editMyDeclarationAPI(data: any) {
  const response = await instance.patch("/coi/editCoi", data);
  return response.data;
}

export async function getChangeApprovalStatusAPI(data: any) {
  const response = await instance.patch("/coi/changeStatusCoi", data);
  return response.data;
}

export async function getDeclarationApprovalAPI(data: any) {
  const response = await instance.get(
    `/coi/getPendingCoi?q=${data?.q}&conflictCategoryMasterId=${data?.conflictCategoryMasterId}&year=${data?.year}&status=${data?.status}`
  );
  return response.data;
}


export async function getDeclarationApprovalDownloadAPI(
  // params?: Record<string, any>
): Promise<AxiosResponse<Blob>> {
  return instance.get('/coi/getPendingCoiDownload', {
    responseType: 'blob',
    // params, // if you need filters/IDs
  });
}



export async function getYearListAPI() {
  const response = await instance.get("/coi/getCoiYear");
  return response.data;
}

export async function getUserDetailsAPI() {
  const response = await instance.get("/users/getCurrentUserDetails");
  // const response = await instance.get('/coi/getCurrentUserDetailsNew');
  return response.data;
}

export async function addCOIChatAPI(data: any) {
  const response = await instance.post("/coi/addCoiChat", data);
  return response.data;
}
